<template>
  <div class="company-card" @click.stop="goToCompany">
    <div class="company-card__header">
      <div class="company-card__logo" v-if="company.AccountType === 'tov'">
        <svg
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.857143 1.75C0.857143 0.783501 1.62465 0 2.57143 0H9.42857C10.3754 0 11.1429 0.783501 11.1429 1.75V12.25C11.6163 12.25 12 12.6417 12 13.125C12 13.6083 11.6163 14 11.1429 14H8.57143C8.09803 14 7.71429 13.6083 7.71429 13.125V11.375C7.71429 10.8917 7.33054 10.5 6.85714 10.5H5.14286C4.66947 10.5 4.28571 10.8917 4.28571 11.375V13.125C4.28571 13.6083 3.90195 14 3.42857 14H0.857143C0.38376 14 0 13.6083 0 13.125C0 12.6417 0.38376 12.25 0.857143 12.25V1.75ZM3.42857 2.625H5.14286V4.375H3.42857V2.625ZM5.14286 6.125H3.42857V7.875H5.14286V6.125ZM6.85714 2.625H8.57143V4.375H6.85714V2.625ZM8.57143 6.125H6.85714V7.875H8.57143V6.125Z"
            fill="white"
          />
          <mask
            id="mask0_10936_3644"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="13"
            height="14"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.978673 1.70344C0.978673 0.76697 1.73783 0.0078125 2.6743 0.0078125H9.45681C10.3933 0.0078125 11.1524 0.76697 11.1524 1.70344V11.8772C11.6207 11.8772 12.0002 12.2568 12.0002 12.725C12.0002 13.1933 11.6207 13.5728 11.1524 13.5728H8.60899C8.14075 13.5728 7.76118 13.1933 7.76118 12.725V11.0294C7.76118 10.5611 7.38161 10.1816 6.91337 10.1816H5.21774C4.74951 10.1816 4.36993 10.5611 4.36993 11.0294V12.725C4.36993 13.1933 3.99034 13.5728 3.52211 13.5728H0.978673C0.510442 13.5728 0.130859 13.1933 0.130859 12.725C0.130859 12.2568 0.510442 11.8772 0.978673 11.8772V1.70344ZM3.52211 2.55125H5.21774V4.24688H3.52211V2.55125ZM5.21774 5.94251H3.52211V7.63813H5.21774V5.94251ZM6.91337 2.55125H8.60899V4.24688H6.91337V2.55125ZM8.60899 5.94251H6.91337V7.63813H8.60899V5.94251Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_10936_3644)">
            <rect
              x="5.95947"
              y="1.06738"
              width="8.47814"
              height="16.4264"
              rx="4.23907"
              fill="#64748B"
            />
          </g>
        </svg>
      </div>
      <div class="company-card__logo" v-else-if="company.AccountType === 'tov'">
        <svg
          width="22"
          height="26"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g mask="url(#mask0_11557_3042)">
            <ellipse
              cx="12.9366"
              cy="15.4405"
              rx="4.13776"
              ry="4.13776"
              fill="white"
            />
            <mask
              id="mask1_11557_3042"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="8"
              y="11"
              width="10"
              height="9"
            >
              <ellipse
                cx="12.9366"
                cy="15.4405"
                rx="4.13776"
                ry="4.13776"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_11557_3042)">
              <ellipse
                cx="14.4887"
                cy="14.9233"
                rx="3.62054"
                ry="3.62054"
                fill="#64748B"
              />
            </g>
            <circle cx="13.1954" cy="27.5948" r="6.98248" fill="white" />
            <mask
              id="mask2_11557_3042"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="6"
              y="20"
              width="15"
              height="15"
            >
              <circle cx="13.1954" cy="27.5948" r="6.98248" fill="white" />
            </mask>
            <g mask="url(#mask2_11557_3042)">
              <circle cx="16.2989" cy="27.5948" r="6.98248" fill="#64748B" />
            </g>
          </g>
        </svg>
      </div>
      <div class="company-card__logo" v-else>
        <svg
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.857143 1.75C0.857143 0.783501 1.62465 0 2.57143 0H9.42857C10.3754 0 11.1429 0.783501 11.1429 1.75V12.25C11.6163 12.25 12 12.6417 12 13.125C12 13.6083 11.6163 14 11.1429 14H8.57143C8.09803 14 7.71429 13.6083 7.71429 13.125V11.375C7.71429 10.8917 7.33054 10.5 6.85714 10.5H5.14286C4.66947 10.5 4.28571 10.8917 4.28571 11.375V13.125C4.28571 13.6083 3.90195 14 3.42857 14H0.857143C0.38376 14 0 13.6083 0 13.125C0 12.6417 0.38376 12.25 0.857143 12.25V1.75ZM3.42857 2.625H5.14286V4.375H3.42857V2.625ZM5.14286 6.125H3.42857V7.875H5.14286V6.125ZM6.85714 2.625H8.57143V4.375H6.85714V2.625ZM8.57143 6.125H6.85714V7.875H8.57143V6.125Z"
            fill="white"
          />
          <mask
            id="mask0_10936_3644"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="13"
            height="14"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.978673 1.70344C0.978673 0.76697 1.73783 0.0078125 2.6743 0.0078125H9.45681C10.3933 0.0078125 11.1524 0.76697 11.1524 1.70344V11.8772C11.6207 11.8772 12.0002 12.2568 12.0002 12.725C12.0002 13.1933 11.6207 13.5728 11.1524 13.5728H8.60899C8.14075 13.5728 7.76118 13.1933 7.76118 12.725V11.0294C7.76118 10.5611 7.38161 10.1816 6.91337 10.1816H5.21774C4.74951 10.1816 4.36993 10.5611 4.36993 11.0294V12.725C4.36993 13.1933 3.99034 13.5728 3.52211 13.5728H0.978673C0.510442 13.5728 0.130859 13.1933 0.130859 12.725C0.130859 12.2568 0.510442 11.8772 0.978673 11.8772V1.70344ZM3.52211 2.55125H5.21774V4.24688H3.52211V2.55125ZM5.21774 5.94251H3.52211V7.63813H5.21774V5.94251ZM6.91337 2.55125H8.60899V4.24688H6.91337V2.55125ZM8.60899 5.94251H6.91337V7.63813H8.60899V5.94251Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_10936_3644)">
            <rect
              x="5.95947"
              y="1.06738"
              width="8.47814"
              height="16.4264"
              rx="4.23907"
              fill="#64748B"
            />
          </g>
        </svg>
      </div>
      <div class="company-card__info">
        <div class="company-card__data">
          <div class="company-card__name">
            <div class="companyName" :class="{ hold: status === 'hold' }">
              {{ company.CompanyName }}
            </div>
          </div>
          <!--          <div class="company-card__code">-->
          <!--            <div class="company-card__code-title">-->
          <!--              {{ $t("company_card.code") }}-->
          <!--            </div>-->
          <!--            <div class="company-card__code-value">12345678</div>-->
          <!--          </div>-->
        </div>
        <div
          class="company-card__status"
          :class="`company-card__status--${status}`"
          v-if="status === 'hold'"
        >
          <div class="company-card__status-icon" v-if="status === 'hold'">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#E0E6F2" />
              <path
                d="M9.01922 14.4001C8.75287 14.4001 8.52089 14.3037 8.32328 14.111C8.12566 13.909 8.02686 13.6704 8.02686 13.395C8.02686 13.1104 8.12137 12.8672 8.31039 12.6652C8.508 12.4633 8.73998 12.3623 9.00633 12.3623C9.28127 12.3623 9.51755 12.4633 9.71516 12.6652C9.91277 12.858 10.0116 13.0967 10.0116 13.3812C10.0116 13.6566 9.91277 13.8953 9.71516 14.0972C9.52614 14.2992 9.29416 14.4001 9.01922 14.4001Z"
                fill="white"
              />
              <path d="M8 4.5H10V11.5H8V4.5Z" fill="white" />
            </svg>
            <div class="company-card__information">
              <div class="information__title">
                <div class="icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="9" cy="9" r="9" fill="#E0E6F2" />
                    <path
                      d="M9.01922 14.4001C8.75287 14.4001 8.52089 14.3037 8.32328 14.111C8.12566 13.909 8.02686 13.6704 8.02686 13.395C8.02686 13.1104 8.12137 12.8672 8.31039 12.6652C8.508 12.4633 8.73998 12.3623 9.00633 12.3623C9.28127 12.3623 9.51755 12.4633 9.71516 12.6652C9.91277 12.858 10.0116 13.0967 10.0116 13.3812C10.0116 13.6566 9.91277 13.8953 9.71516 14.0972C9.52614 14.2992 9.29416 14.4001 9.01922 14.4001Z"
                      fill="white"
                    />
                    <path d="M8 4.5H10V11.5H8V4.5Z" fill="white" />
                  </svg>
                </div>
                <div class="text">
                  <span
                    >Інформація про те, чому компанія деактивована і як її
                    активувати</span
                  >
                </div>
              </div>
              <div class="information__link">
                <span>Перейти до FAQ</span>
                <arrow-button @click="goToFaq"></arrow-button>
              </div>
            </div>
          </div>
          {{ $t(`company_status.${status}`) }}
        </div>
      </div>
      <!--      <div class="company-card__role">-->
      <!--        <div class="role">-->
      <!--          <div class="icon">-->
      <!--            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">-->
      <!--              <path d="M4.85708 6.33335C6.27725 6.33335 7.42852 5.13944 7.42852 3.66668C7.42852 2.19391 6.27725 1 4.85708 1C3.43692 1 2.28564 2.19391 2.28564 3.66668C2.28564 5.13944 3.43692 6.33335 4.85708 6.33335Z" stroke="#67768A" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--              <path d="M9.1084 1C9.91316 1 10.685 1.28095 11.254 1.78105C11.8231 2.28115 12.1428 2.95943 12.1428 3.66668C12.1428 4.37392 11.8231 5.0522 11.254 5.5523C10.685 6.0524 9.91316 6.33335 9.1084 6.33335" stroke="#67768A" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--              <path d="M1 8.3843C1.43497 7.75064 2.01252 7.23345 2.68387 6.87642C3.35521 6.51939 4.10063 6.33301 4.85716 6.33301C5.61369 6.33301 6.3591 6.51939 7.03045 6.87642C7.70179 7.23345 8.27934 7.75064 8.71431 8.3843" stroke="#67768A" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--              <path d="M9.14307 6.33301C9.89966 6.33253 10.6452 6.5187 11.3166 6.87577C11.9881 7.23284 12.5655 7.75028 13.0002 8.3843" stroke="#67768A" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--            </svg>-->

      <!--          </div>-->
      <!--          <div class="name">Адміністратор</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="company-card__arrow" v-if="status === 'active'">-->
      <!--        <arrow-button @click="goToCompany"></arrow-button>-->
      <!--      </div>-->
    </div>
    <div class="company-card__body">
      <div class="company-card__erdpou">
        <div class="label">
          <span>{{ $t('company_card.code') }}</span>
        </div>
        <div class="value">{{ company.Edrpou ? company.Edrpou : '-' }}</div>
      </div>
      <div class="company-card__roles">
        <div class="label">
          <span>{{ $t('company_card.role') }}</span>
        </div>
        <div class="value">{{ translateCompanySlug }}</div>
      </div>
      <div class="company-card__balance">
        <div class="label">
          <div class="name">{{ $t('company_card.purse') }}</div>
        </div>
        <div class="value">
          <!--          {{ companyBalance }} <span class="currency">UAH</span>-->
          {{ companyBalance }}
        </div>
      </div>
    </div>
    <div class="company-card__footer">
      <company-card-hint
        :company-status="status"
        :company="company"
        v-if="shouldShowStatus"
      ></company-card-hint>
      <company-card-actions
        :company-status="status"
        :company="company"
        class="company-card__actions"
        v-else-if="!isMobile"
      ></company-card-actions>
    </div>
  </div>
</template>

<script>
import CompanyCardHint from '@vue-app/components/company/card/CompanyCardHint.vue'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import CompanyCardActions from '@vue-app/components/company/card/CompanyCardActions.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import { formatCoinsToText } from '@js-app/services/helpers/numbers'

export default {
  name: 'CompanyCard',
  components: { CompanyCardActions, ArrowButton, CompanyCardHint },
  mixins: [responsiveMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async goToCompany() {
      await this.$router.push(`/cabinet/company/${this.company.ID}`)
    },

    async goToFaq() {
      // TODO: Create FAQ page component
    },
  },
  computed: {
    locale() {
      let lang = this.$i18n?.locale ?? 'en'
      return lang === 'ua' ? 'uk' : lang
    },
    status() {
      switch (this.company.CompanyStatus) {
        case 1:
          return 'review'
        case 2:
          return 'hold'
        case 3:
          return 'active'
      }
    },
    translateCompanySlug() {
      let slug = this.company.RoleSlug

      if (typeof slug === 'string') {
        try {
          slug = JSON.parse(slug)
        } catch {
          return '-'
        }
      }

      return slug[this.locale] ?? slug ?? ''
    },
    companyBalance() {
      return formatCoinsToText(this.company.balance ?? 0)
    },
    shouldShowStatus() {
      return this.isMobile ? this.status === 'review' : this.status !== 'active'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/mixins';
@import '@css-app/variables';
:deep(.information__link) {
  .arrow-button {
    width: 18px;
    height: 18px;

    svg {
      max-width: 3px;
    }
  }
}
.company-card__status-icon {
  position: relative;
}
.company-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 22px;
  max-width: 1000px;
  width: 100%;
  cursor: pointer;
  &__information {
    position: absolute;
    top: -100px;
    display: none;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    background-color: #fff;
    border-radius: 12px;
    border: 1px solid #f4f3fc;
    z-index: 100;

    .information__title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 10px;
      color: #67768a;

      .icon {
        display: flex;
        align-items: center;
      }
    }

    .information__link {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-left: 28px;

      span {
        font-size: 10px;
        color: #64748B;
      }

      .arrow-button {
        width: 18px;
        height: 18px;
      }
    }
  }

  &__header {
    padding: 20px 25px;
    //padding: 25px 21px 25px 17px;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    flex-shrink: 1;
    //align-items: center;
  }

  &__logo {
    background-color: #64748B;
    border-radius: 8px;
    width: 26px;
    //width: 5%;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__info {
    display: flex;
    align-items: flex-start;
    flex: 1;
    //margin-right: 20px;
  }

  &__data {
    margin-right: 26px;
  }

  &__name {
    font-weight: 600;
    font-size: pxToRem(20);
    line-height: pxToRem(25);
    color: #465a8b;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .companyName {
      max-width: max-content;
			color: black;

      &.hold {
        color: #b9c4d8;
      }
    }
  }

  &__code {
    display: flex;
    align-items: center;
    margin-top: 5px;

    &-title {
      font-weight: 400;
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      margin-right: 4px;
      color: #909cb0;
    }

    &-value {
      font-weight: 600;
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      margin-right: 4px;
      color: #909cb0;
    }
  }

  &__status {
    display: flex;
    gap: 10px;
    //border-radius: 6px;
    //padding: 11px 25px 14px;
    white-space: nowrap;
    font-weight: 500;
    font-size: pxToRem(14);
    line-height: 22px;

    &--review {
      //background: #e9f0ff;
      color: #e9f0ff;
    }

    &--hold {
      //background-color: #ffe6b6;
      color: #e0e6f2;
    }

    &--active {
      //background-color: #e1ffe0;
    }
  }

  .company-card__role {
    margin-left: auto;

    .role {
      display: flex;
      align-items: center;
      gap: 5px;
      border: 1px solid #f4f5f7;
      background-color: #f4f5f7;
      border-radius: 18px;
      padding: 3px 7px;

      .name {
        font-size: 10px;
        line-height: 12px;
        font-weight: 500;
        color: #585f6d;
      }
    }
  }

  .company-card__status-icon {
    position: relative;
    display: flex;
    align-items: center;

    &:hover {
      .company-card__information {
        display: flex;
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 100%;
      left: 200px;
      transform: translateX(-50%);
      padding: 10px 200px;
      z-index: 100;
    }
  }

  &__arrow {
    margin-left: auto;
  }

  &__body {
    display: flex;
    //align-items: center;
    gap: 30px;
    border-top: 1px solid rgba(224, 230, 242, 0.7);
    padding: 20px 25px;

    .company-card__erdpou,
    .company-card__roles,
    .company-card__balance {
      .label {
        font-size: 12px;
        color: #b9c4d8;
        font-weight: 400;
        line-height: 15px;
      }

      .value {
        padding-top: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #585f6d;
      }
    }

    .company-card__balance {
      display: flex;
      flex-direction: column;
      //gap: 5px;
      //padding: 1px 10px 1px 4px;
      //border: 1px solid #e0e6f2;
      //border-radius: 28px;
      //margin-left: 20px;
      cursor: default;
      flex-shrink: 0;

      &-icon {
        display: flex;

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e0e6f2;
          border-radius: 44px;
          width: 13px;
          height: 13px;
          margin-right: 5px;
        }

        .name {
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          color: #b9c4d8;
        }

        //svg {
        //  width: 100%;
        //  height: 100%;
        //}
      }

      &-value {
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #27365b;
        padding-left: 18px;

        span {
          font-weight: 300;
        }
      }
    }
  }

  &__footer {
    border-top: 1px solid rgba($stroke, 0.7);
    //padding: 20px 17px;
    //padding: 20px 25px;
  }
}
@media screen and (max-width: 992px) {
  .company-card {
    border-radius: 20px;
    &__header {
      padding: 13px 10px 13px;
    }

    &__info {
      display: flex;
      flex-direction: column;
    }

    &__logo {
      width: 41px;
      height: 41px;
      margin-bottom: auto;
    }

    &__name {
      font-size: pxToRem(14);
      line-height: pxToRem(17);
    }

    &__status {
      margin-top: 10px;
      padding: 7px 13px 8px;
      border-radius: 42px;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
    }

    &__footer {
      padding: 8px 10px 10px;

      &:empty {
        display: none;
      }
    }

    &__actions {
      display: none;
    }
  }
}
</style>
